export default __webpack_public_path__ + "static/media/notTrestle.271bfb9e.svg";